import { useTranslation } from 'react-i18next';
import { ReactComponent as TrashIcon } from 'assets/icons/tresh.svg';
import clsx from 'clsx';
import IconButton from 'components/IconButton/IconButton';
import Table from 'components/Table/Table';
import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableHead from 'components/Table/TableHead';
import TableRow from 'components/Table/TableRow';
import formattedNumberWithComma from 'utils/formattedNumberWithComma';
import getAverageStatEmployees from 'utils/getAvarageMembers';

import type ISelectSupplierTable from './interfaces/IItemsTable';

import styles from './scss/ItemsTable.module.scss';

function ItemsTable({
  items,
  headCells,
  isInfoTable,
  onDeleteItem,
  isViewOnly,
}: ISelectSupplierTable) {
  const { t } = useTranslation();
  const hyphen = t('common.hyphen');

  const getMinMembers = (countMax: number) => {
    const count = getAverageStatEmployees(countMax || 0);
    return formattedNumberWithComma(count);
  };

  return (
    <div className={styles.root}>
      <div className={styles.tableBodyScroll}>
        <Table
          className={clsx(styles.table, {
            [styles.tableInfoTable]: isInfoTable,
          })}
        >
          <TableHead className={clsx(styles.header, {
            [styles.headerInfoTable]: isInfoTable,
          })}
          >
            {headCells
              .filter((headCell) => !(isViewOnly && headCell.id === 'actions'))
              .map(({
                id, label,
              }) => (
                <TableCell head className={styles.tableCell} key={id}>
                  <div>
                    <span>{t(label)}</span>
                  </div>
                </TableCell>
              ))}
          </TableHead>
          <TableBody className={styles.body}>
            {items ? items?.map((item, index) => (
              <TableRow key={[item.id, index].join('_')}>
                <TableCell>
                  <div className={styles.staticCell}>
                    <span>{item.companyName}</span>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={styles.verticalList}>
                    {item.stockTickers && item.stockTickers?.length > 0
                      ? item.stockTickers.map((ticker, indexStock) => (
                        <span key={[ticker, indexStock].join('_')}>{ticker}</span>
                      )) : hyphen}
                  </div>
                </TableCell>
                <TableCell>
                  {item.website || hyphen}
                </TableCell>
                <TableCell>
                  <div className={styles.verticalList}>
                    {item.sectors && item.sectors?.length > 0 ? item.sectors.map((sector, indexStock) => (
                      <span key={[sector, indexStock].join('_')}>{sector}</span>
                    )) : hyphen}
                  </div>
                </TableCell>
                <TableCell>
                  {item.type || hyphen}
                </TableCell>
                <TableCell>
                  {`${getMinMembers(item.employeeCount)} - ${formattedNumberWithComma(item.employeeCount)}`}
                </TableCell>
                {!isViewOnly ? (
                  <TableCell>
                    <IconButton
                      icon={<TrashIcon />}
                      onClick={() => onDeleteItem?.(item.id || 0)}
                    />
                  </TableCell>
                ) : null}
              </TableRow>
            )) : null}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

export default ItemsTable;
